<div class="section over-hide">
    <div class="section padding-top-120 padding-top-mob-nav section-background-rana-biz-conf rana-shell-flush">
        <div class="section-1400 rana-full-bleed">
            <div class="container-fluid px-0">

                <div class="row no-gutters rana-shell">

                    <!-- LEFT FIXED MENU -->
                    <div class="col-lg-4 rana-shell-rail">

                        <div class="section border-4 p-3 p-xl-4 z-bigger sticky-wrapper rana-nav-rail">

                            <div class=" col-12 mt-4 font-weight-600 text-center color-primary">
                                <i class="uil uil-users-alt size-22 mr-2 pr-1"></i>
                                Business Conference 2026
                            </div>

                            <div class="col-12 mt-3 d-lg-none">
                                <button type="button" class="rana-nav-mobile-toggle" data-toggle="collapse"
                                        data-target="#bizConfNavRailLinks" aria-expanded="false"
                                        aria-controls="bizConfNavRailLinks">
                                    <span>Menu</span>
                                    <i class="uil uil-angle-down size-20"></i>
                                </button>
                            </div>
                            <div class="col-12 collapse d-lg-block" id="bizConfNavRailLinks">
                            <a href="javascript:void(0)"
                               class="btn btn-user-profile btn-fluid justify-content-start mt-1 px-3"
                               data-toggle="collapse" data-target="#collapseBizDetails" aria-expanded="true">
                                Conference Details
                            </a>
                            <a href="javascript:void(0)"
                               class="btn btn-user-profile btn-fluid justify-content-start px-3 mt-1 mb-1" data-toggle="collapse"
                               data-target="#collapseBizLeadership" aria-expanded="false">
                                Conference Leadership & Speakers
                            </a>
                            <a href="javascript:void(0)"
                               class="btn btn-user-profile btn-fluid justify-content-start mt-1 px-3"
                               data-toggle="collapse"
                               data-target="#collapseBizSchedule"
                               aria-expanded="false">

                                Event Schedule
                            </a>
                            <a href="javascript:void(0)"
                               class="btn btn-user-profile btn-fluid justify-content-start mt-1 px-3"
                               data-toggle="collapse"
                               data-target="#collapseBizPpt"
                               aria-expanded="false" *ngIf="userid!=null && userid">
                                Conference Presentations
                            </a>

                            <a href="javascript:void(0)"
                               class="btn btn-user-profile btn-fluid justify-content-start mt-1 px-3" data-toggle="collapse"
                               data-target="#collapseBizList" aria-expanded="false">
                                Registered Attendees
                            </a>
                            <a href="javascript:void(0)"
                               class="btn btn-user-profile btn-fluid justify-content-start mt-1 px-3 mb-4"
                               data-toggle="collapse" data-target="#collapseBizForm" aria-expanded="false">
                                Conference Registration
                            </a>
                            <div class="ed mt-4"></div>
                            </div>
                        </div>
                    </div>

                    <!-- RIGHT CONTENT AREA -->
                    <div class="col-lg-8 mt-4 mb-2 mt-lg-0 rana-shell-main">
                        <div class="section border-4 p-3 p-xl-4 rana-shell-main-inner">

                            <!-- WRAPPER THAT CONTROLS ACCORDION BEHAVIOR -->
                            <div id="bizAccordion">

                                <!-- COLLAPSE - REGISTERED ATTENDEES -->
                                <div id="collapseBizList" class="collapse p-0 m-3" data-parent="#bizAccordion">
                                    <div class="card-body p-0">
                                        <div class="row">

                                            <div class="col-12">
                                                <h5 class="mb-3">Registered Participants - Business Conference 2026</h5>
                                            </div>

                                            <div class="col-12 pb-3">
                                                <div class="section divider divider-gray"></div>
                                            </div>

                                            <div class="mt-4">

                                                <div class="d-none d-md-block">
                                                    <!-- DESKTOP TABLE -->
                                                  <div class="rana-table-flat">
                                                    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table rana-table">
                                                        <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Full Name</th>
                                                            <th>Donation Amount</th>
                                                            <th>Badge</th>
                                                            <th>Payment Type</th>
                                                            <th *ngIf="user?.email">Action</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody></tbody>
                                                    </table>
                                                  </div>
                                                </div>

                                                <ng-template #badgeTpl let-e="adtData"><span class="d-inline-block">
                                                    <span class="rana-badge rana-badge-danger">
                                                        {{ packageLabels[e.packageType] || e.packageType }}
                                                        <span *ngIf="e.additionalRoom"> + Additional Room</span>
                                                        <span *ngIf="e.kidsOption"> + Kids Option</span>
                                                    </span>

                                                    <span *ngIf="e.speaker"><br></span>
                                                    <span *ngIf="e.speaker" class="rana-badge rana-badge-success">Speaker</span>

                                                    <span *ngIf="e.donationAmount"><br></span>

                                                    <span *ngIf="e.donationAmount > 500 && e.donationAmount < 1000"
                                                          class="badge donor-basic">Donor</span>

                                                    <span *ngIf="e.donationAmount >= 1000 && e.donationAmount < 2000"
                                                          class="badge donor-gold">Gold Donor</span>

                                                    <span *ngIf="e.donationAmount >= 2000 && e.donationAmount < 3000"
                                                          class="badge donor-platinum">Platinum Donor</span>

                                                    <span *ngIf="e.donationAmount >= 3000"
                                                          class="badge donor-diamond">Diamond Donor</span>
                                                </span></ng-template>

                                                <ng-template #actionTpl let-e="adtData"><span class="d-inline-block">
                                                    <button class="btn btn-sm btn-primary"
                                                            *ngIf="e.email === user?.email"
                                                            [disabled]="true"
                                                            (click)="editRegistration(e)">
                                                        Edit
                                                    </button>
                                                </span></ng-template>

                                                <!-- MOBILE CARD VIEW -->
                                                <div class="d-md-none">

                                                    <div class="card mb-3"
                                                         *ngFor="let e of registrationList; let i = index;"
                                                         [@rowSlideIn]>

                                                        <div class="card-body p-2">

                                                            <!-- Row number -->
                                                            <div class="small text-muted mb-1">
                                                                #{{ i + 1 }}
                                                            </div>

                                                            <!-- Full Name -->
                                                            <div class="fw-bold"><strong>Name:</strong> {{
                                                                    e.firstName
                                                                }} {{ e.lastName }}
                                                            </div>

                                                            <!-- Amount -->
                                                            <div *ngIf="e.donationAmount > 500" class="mt-1">
                                                                <strong>Donation Amount:</strong> {{ e.donationAmount }}
                                                            </div>

                                                            <!-- Badge section -->
                                                            <div class="mt-2">
                                                                <span class="rana-badge rana-badge-danger">

                                                                    {{ packageLabels[e.packageType] || e.packageType }}
                                                                    <span *ngIf="e.additionalRoom"> + Additional
                                                                        Room</span>
                                                                    <span *ngIf="e.kidsOption"> + Kids Option</span>
                                                                </span>

                                                                <div class="mt-1" *ngIf="e.speaker">
                                                                    <span class="rana-badge rana-badge-success">Speaker</span>
                                                                </div>

                                                                <div class="mt-1"
                                                                     *ngIf="e.donationAmount > 500 && e.donationAmount < 1000">
                                                                    <span class="badge donor-basic">Donor</span>
                                                                </div>

                                                                <div class="mt-1"
                                                                     *ngIf="e.donationAmount >= 1000 && e.donationAmount < 2000">
                                                                    <span class="badge donor-gold">Gold Donor</span>
                                                                </div>

                                                                <div class="mt-1"
                                                                     *ngIf="e.donationAmount >= 2000 && e.donationAmount < 3000">
                                                                    <span class="badge donor-platinum">Platinum
                                                                        Donor</span>
                                                                </div>

                                                                <div class="mt-1" *ngIf="e.donationAmount >= 3000">
                                                                    <span class="badge donor-diamond">Diamond
                                                                        Donor</span>
                                                                </div>

                                                            </div>

                                                            <!-- Payment Type -->
                                                            <div class="mt-2">
                                                                <strong>Payment:</strong> {{ e.paymentType }}
                                                            </div>
                                                            <div class="mt-2" *ngIf="user?.email">
                                                                <button class="btn btn-sm btn-primary"
                                                                        *ngIf="e.email === user?.email"
                                                                        [disabled]="e.paymentType === 'stripe'"
                                                                        class="btn btn-sm btn-primary"
                                                                        (click)="editRegistration(e)">
                                                                    Edit
                                                                </button>
                                                            </div>

                                                        </div>
                                                    </div>

                                                </div>

                                            </div>


                                            <!-- NO DATA -->
                                            <div *ngIf="registrationList && registrationList.length === 0"
                                                 class="text-center mt-5" [@fadeSlideIn]>
                                                <h4>No Conference Registrations Found</h4>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <!-- COLLAPSE - CONFERENCE PPT UPLOAD & LIST -->
                                <div id="collapseBizPpt" class="collapse p-0 m-3" data-parent="#bizAccordion">
                                    <div class="card-body p-0">

                                        <div class="row">

                                            <div class="col-12">
                                                <h5 class="mb-3">📊 Conference Presentations</h5>
                                            </div>

                                            <div class="col-12 pb-3">
                                                <div class="section divider divider-gray"></div>
                                            </div>

                                            <!-- UPLOAD FORM -->
                                            <div class="col-12 mb-4">
                                                <div class="border rounded p-3 bg-light">

                                                    <h6 class="mb-3">Upload Your Presentation</h6>

                                                    <form class="nfr-form-standard" [formGroup]="pptForm" (ngSubmit)="uploadPpt()">

                                                        <div class="mb-2">
                                                            <label class="small font-weight-600">Presentation Title</label>
                                                            <input type="text"
                                                                   class="form-control"
                                                                   placeholder="Enter presentation title"
                                                                   formControlName="title">
                                                        </div>
                                                        <div class="mb-2">
                                                            <label class="small font-weight-600">Company Name</label>
                                                            <input type="text"
                                                                   class="form-control"
                                                                   placeholder="Enter Your company Name"
                                                                   formControlName="companyName">
                                                        </div>

                                                        <div class="mb-2">
                                                            <label class="small font-weight-600">Topic Description</label>
                                                            <textarea class="form-control"
                                                                      rows="3"
                                                                      placeholder="Brief description of the topic"
                                                                      formControlName="description"></textarea>
                                                        </div>

                                                        <div class="mb-3">
                                                            <label class="small font-weight-600">Upload PPT / PPTX</label>
                                                            <input type="file"
                                                                   class="form-control"
                                                                   accept=".ppt,.pptx"
                                                                   (change)="onPptFileSelected($event)">
                                                        </div>

                                                        <button class="btn btn-dark-primary">
                                                            Upload Presentation
                                                        </button>

                                                    </form>
                                                </div>
                                            </div>

                                            <!-- PPT LIST -->
                                            <div class="col-12" *ngIf="pptList && pptList.length > 0">

                                                <h6 class="mb-3">Available Presentations</h6>

                                                <div class="row">

                                                    <div class="col-md-6 mb-3"
                                                         *ngFor="let ppt of pptList">

                                                        <div class="border rounded p-3 h-100 landing-shadow-2">

                                                            <h6 class="mb-1 text-rana-primary">
                                                                {{ ppt.title }}
                                                            </h6>

                                                            <p class="text-small mb-2">
                                                                {{ ppt.description }}
                                                            </p>

                                                            <small class="mt-1 text-sm">
                                                                {{ ppt.uploadedByName }}<br>
                                                            </small>
                                                            <small class="mt-1 text-sm">
                                                                {{ ppt.email }}<br>
                                                            </small>
                                                            <p class="text-small mb-2">
                                                                {{ ppt?.companyName }}
                                                            </p>


                                                            <div>
                                                                <button class="btn btn-sm btn-outline-primary"
                                                                        (click)="downloadPpt(ppt)">
                                                                    <i class="uil uil-download-alt mr-1"></i>
                                                                    Download
                                                                </button>
                                                            </div>

                                                        </div>
                                                    </div>

                                                </div>
                                            </div>

                                            <!-- NO PPTS -->
                                            <div class="col-12 text-center mt-4"
                                                 *ngIf="pptList && pptList.length === 0">
                                                <h6>No presentations uploaded yet</h6>
                                                <p class="text-muted text-small">
                                                    Be the first to share your presentation.
                                                </p>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <!-- COLLAPSE - EVENT SCHEDULE -->
                                <div id="collapseBizSchedule" class="collapse p-0" data-parent="#bizAccordion">
                                    <div class="card-body p-0">

                                        <div class="row">
                                            <div class="col-12">
                                                <h5 class="mb-3">2026 RANA Global Business Conference – Schedule</h5>
                                            </div>

                                            <div class="col-12 pb-3">
                                                <div class="section divider divider-gray"></div>
                                            </div>

                                            <!-- DAY 1 -->
                                            <div class="col-12 mb-4">
                                                <div class="schedule-day-card">
                                                    <h6 class="schedule-day-title">
                                                        <span class="day-badge">Day 1</span>
                                                        Friday, Jan 30, 2026
                                                    </h6>

                                                    <ul class="list-unstyled schedule-list">
                                                        <li>
                                                            <span class="time">2:00 – 5:00 PM</span>
                                                            <span class="event">Welcome & Registration</span>
                                                        </li>
                                                        <li>
                                                            <span class="time">5:00 – 7:00 PM</span>
                                                            <span class="event">Networking & High Tea <em>(Speaker Badges)</em></span>
                                                        </li>
                                                        <li>
                                                            <span class="time">7:00 – 7:30 PM</span>
                                                            <span class="event">Welcome Addresses & Leadership Introductions</span>
                                                        </li>
                                                        <li>
                                                            <span class="time">7:30 – 8:30 PM</span>
                                                            <span class="event">Ice Breaker Session (All Delegates)</span>
                                                        </li>
                                                        <li>
                                                            <span class="time">8:30 – 9:30 PM</span>
                                                            <span class="event">Dinner</span>
                                                        </li>
                                                        <li>
                                                            <span class="time">9:30 – 10:30 PM</span>
                                                            <span class="event">Open Mic & Cultural Sharing</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>


                                            <!-- DAY 2 -->
                                            <div class="col-12 mb-4">
                                                <div class="schedule-day-card">
                                                    <h6 class="schedule-day-title">
                                                        <span class="day-badge">Day 2</span>
                                                        Saturday, Jan 31, 2026
                                                    </h6>

                                                    <ul class="list-unstyled schedule-list">
                                                        <li>
                                                            <span class="time">7:00 – 8:45 AM</span>
                                                            <span class="event">Breakfast</span>
                                                        </li>
                                                        <li>
                                                            <span class="time">9:00 – 10:15 AM</span>
                                                            <span class="event">Inaugural Ceremony & Guest of Honor Address</span>
                                                        </li>
                                                        <li>
                                                            <span class="time">10:15 – 10:30 AM</span>
                                                            <span class="event">Magazine Unveiling</span>
                                                        </li>
                                                        <li>
                                                            <span class="time">10:30 – 12:30 PM</span>
                                                            <span class="event">Business Presentations (Sessions 1–5)</span>
                                                        </li>
                                                        <li>
                                                            <span class="time">12:30 – 1:45 PM</span>
                                                            <span class="event">Lunch</span>
                                                        </li>
                                                        <li>
                                                            <span class="time">2:00 – 4:00 PM</span>
                                                            <span class="event">Business Presentations (Sessions 6–9)</span>
                                                        </li>
                                                        <li>
                                                            <span class="time">4:15 – 5:14 PM</span>
                                                            <span class="event">Panel Discussion – RANA Business Success Stories</span>
                                                        </li>
                                                        <li>
                                                            <span class="time">5:15 – 6:29 PM</span>
                                                            <span class="event">Business Presentations (Sessions 10–12)</span>
                                                        </li>
                                                        <li>
                                                            <span class="time">6:30 – 7:45 PM</span>
                                                            <span class="event">Refreshments & Appetizers</span>
                                                        </li>
                                                        <li>
                                                            <span class="time">7:45 – 9:00 PM</span>
                                                            <span class="event">Dinner & Recognition Ceremony</span>
                                                        </li>
                                                        <li>
                                                            <span class="time">9:15 – 9:45 PM</span>
                                                            <span class="event">Cultural Performances</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>


                                            <!-- DAY 3 -->
                                            <div class="col-12 mb-4">
                                                <div class="schedule-day-card">
                                                    <h6 class="schedule-day-title">
                                                        <span class="day-badge">Day 3</span>
                                                        Sunday, Feb 1, 2026
                                                    </h6>

                                                    <ul class="list-unstyled schedule-list">
                                                        <li>
                                                            <span class="time">7:30 – 8:45 AM</span>
                                                            <span class="event">Breakfast</span>
                                                        </li>
                                                        <li>
                                                            <span class="time">8:45 – 12:10 PM</span>
                                                            <span class="event">Business Presentations (Sessions 13–21)</span>
                                                        </li>
                                                        <li>
                                                            <span class="time">12:10 – 12:30 PM</span>
                                                            <span class="event">Closing Remarks & Vote of Thanks</span>
                                                        </li>
                                                        <li>
                                                            <span class="time">12:30 – 1:30 PM</span>
                                                            <span class="event">Lunch & Adjourn</span>
                                                        </li>
                                                        <li>
                                                            <span class="time">1:30 – 1:55 PM</span>
                                                            <span class="event">Hotel Checkout</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                </div>

                                <!-- COLLAPSE - REGISTRATION FORM -->
                                <div id="collapseBizLeadership" class="collapse  p-0 " data-parent="#bizAccordion">
                                    <div class="card-body p-0">
                                        <div class="row">
                                            <div class="col-12">
                                                <h5 class="mb-3">Business Conference 2026 Leadership</h5>
                                            </div>
                                            <!-- Guest of Honor -->
                                            <div class="col-md-4 mb-4">
                                                <div class="leader-card text-center">

                                                    <img src="/assets/img/biz-conf/Danny.jpg"  class="img-fluid w-100 speaker-img" alt="Guest of Honor">
                                                    <h6 class="mb-0 text-rana-primary ">Danny Gaekwad</h6>
                                                    <small class="text-muted text-sm ">Guest of Honors</small>
                                                    <p class="mt-2 text-small">
                                                        Danny Gaekwad is a first-generation American entrepreneur and community leader based in Florida, widely recognized as a visionary and fearless change agent across industry, community, and public life. Known for stepping forward where others step back, Danny’s journey—from India to the United States—embodies resilience, leadership, and the enduring spirit of the American Dream.
                                                    </p>
                                                </div>
                                            </div>

                                            <!-- President -->
                                            <div class="col-md-4 mb-4">
                                                <div class="leader-card text-center">

                                                    <img src="/assets/img/biz-conf/Naresh.jpeg"  class="img-fluid w-100 speaker-img" alt="Guest of Honor">
                                                    <h6 class="mb-0 text-rana-primary">Nareshkumar Chavda</h6>
                                                    <small class="text-muted text-sm ">President, RANA NEC <br>(2025 - 2027)</small>
                                                    <p class="mt-2 text-small">
                                                        Mr. Nareshkumar Chavda is a Senior Canadian Immigration Consultant (RCIC), Commissioner of Oath (Ontario), and President & CEO of Globayan Immigration, with operations in Canada and India, and a recognized expert at Pravasi Bharatiya Divas forums.
                                                    </p>
                                                    <a
                                                            href="/assets/vid/conf-speaker/Naresh.mp4"
                                                            class="glightbox btn btn-dark-primary  animated m-2"
                                                            data-type="video"
                                                    >
                                                        Watch More
                                                        <i
                                                                class="uil uil-video size-22 m-2 pr-1"
                                                                title="watch video"></i>
                                                    </a>

                                                </div>
                                            </div>

                                            <!-- Convener -->
                                            <div class="col-md-4 mb-4">
                                                <div class="leader-card text-center">

                                                    <img src="/assets/img/biz-conf/Kamal.png"  class="img-fluid w-100 speaker-img" alt="Guest of Honor">
                                                    <h6 class="mb-0 text-rana-primary">Kamal Singh Tomar</h6>
                                                    <small class="text-muted text-sm">Co-Convener, RANA</small>
                                                    <p class="mt-2 text-small">
                                                        Kamal is a seasoned marketing leader known for driving growth and expansion for global organizations across India, the U.S., and Canada.
                                                    </p>
                                                    <a
                                                            href="/assets/vid/conf-speaker/Kamal.mp4"
                                                            class="glightbox btn btn-dark-primary  animated m-2"
                                                            data-type="video"
                                                    >
                                                        Watch More
                                                        <i
                                                                class="uil uil-video size-22 m-2 pr-1"
                                                                title="watch video"></i>
                                                    </a>

                                                </div>
                                            </div>



                                            <div class="col-md-12 mb-4 ">
                                                <div class="leader-card text-center ">

                                                    <h6 class="mb-0 text-rana-primary">Other Key Contributors</h6>

                                                    <p class="mt-2 text-small">
                                                        <span class="text-rana-primary">Chair:</span> Dr. Daleep Singh Rathore
                                                        <span class="color-red">|</span> <span class="text-rana-primary"> CO-Chair:</span> Mukesh Parmar
                                                        <span class="color-red">|</span> <span class="text-rana-primary"> Convener:</span> Dr. Sanket Chauhan
                                                        <span class="color-red">|</span> <span class="text-rana-primary"> Treasurer:</span> Hitesh Chudasama
                                                        <span class="color-red">|</span> <span class="text-rana-primary"> Program:</span> Amitesh Dhundhel
                                                        <span class="color-red">|</span> <span class="text-rana-primary"> Media/IT:</span> Nirbhay Kumar Singh
                                                        <span class="color-red">|</span> <span class="text-rana-primary"> Magazine:</span> Rajendra Chandrawat
                                                        <span class="color-red">|</span> <span class="text-rana-primary"> Cultural Secratory:</span> Neha Dhundhel
                                                     </p>
                                                    <small class="text-muted font-italic">National Leadership & Executive Committee</small>
                                                    <p class="mt-2 text-small">
                                                        <span class="text-rana-primary">Vice President:</span> Surendra Singh Chauhan
                                                        <span class="color-red">|</span> <span class="text-rana-primary"> General Secretory:</span> Shweta Singh
                                                        <span class="color-red">|</span> <span class="text-rana-primary"> IT Secretory:</span> Kandarp Singh Sengar
                                                        <span class="color-red">|</span> <span class="text-rana-primary"> Treasurer:</span> Pravinsinh Parmar
                                                        <span class="color-red">|</span> <span class="text-rana-primary"> Magazine Secretory:</span> Mahendra Singh Jadon
                                                        <span class="color-red">|</span> <span class="text-rana-primary"> Education Secretary:</span> Meenakshi Sarangdevot
                                                        <span class="color-red">|</span> <span class="text-rana-primary"> Cultural Secratory:</span> Reenaba Chudasama
                                                    </p>
                                                </div>
                                            </div>




                                        </div>
                                    </div>














                                                <div class="section over-hide padding-top-bottom-40 section-background-rana-biz-conf-speaker">
                                                    <div >
                                                        <div class="container-fluid">
                                                            <div class="row mb-5 pb-4">
                                                                <div class="col-lg-12 align-self-center">
                                                                    <h6 class="color-gray text-uppercase mb-2">
                                                                        Meet our Speakers
                                                                    </h6>
                                                                    <h3 class="display-6 mb-0 color-cyan">
                                                                        Industry leaders, entrepreneurs, and innovators<br>
                                                                        <span class="font-weight-600">
                                                                    shaping conversations at the <span class="color-primary">RANA Business Conference 2026</span>
                                                                </span>
                                                                    </h3>
                                                                    <p class="mt-3 color-gray-light size-16">
                                                                        Our distinguished speakers bring deep expertise across business, technology, leadership,
                                                                        and community entrepreneurship. Join them for insightful sessions, real-world strategies,
                                                                        and meaningful networking.
                                                                    </p>
                                                                </div>

                                                            </div>


                                                            <div class="row">
                                                                <div class="col-12">
                                                                    <div
                                                                        #swiperContainer
                                                                        class="section swiper-team padding-bottom-40 swiper-container"
                                                                    >
                                                                        <div class="swiper-wrapper">

                                                                            <div class="swiper-slide" *ngFor="let speaker of speakers">
                                                                                <div class="section blog-wrap-4 full-img border-4 bg-white">
                                                                                    <div class="row">
                                                                                        <div class="col-12">


                                                                                            <div class="section p-0">
                                                                                                <img
                                                                                                        [src]="speaker.image"
                                                                                                        [alt]="speaker.name"
                                                                                                        class="img-fluid w-100 speaker-img"
                                                                                                />
                                                                                            </div>


                                                                                            <div class="section clearfix p-2">


                                                                                                <a
                                                                                                        *ngFor="let tag of speaker.tags"
                                                                                                        class="tag new w-2 mx-1 mt-1"
                                                                                                >
                                                                                                    {{ tag }}
                                                                                                </a>

                                                                                                <p class="mb-1 mt-3 size-15 text-muted">
                                                                                                    {{ speaker.role }}
                                                                                                </p>

                                                                                                <h5 class="mb-2">
                                                                                                    <span class="font-weight-600">{{ speaker.name }}</span>
                                                                                                </h5>

                                                                                                <p class="mb-2 size-15 text-muted">
                                                                                                    {{ speaker.company }}
                                                                                                </p>

                                                                                                <p class="mb-3">
                                                                                                    Topic: {{ speaker.topic }}
                                                                                                </p>



                                                                                                <a
                                                                                                        *ngIf="speaker.video"
                                                                                                        [href]="speaker.video"
                                                                                                        class="glightbox btn-sm btn-dark animated m-2"
                                                                                                        data-type="video"
                                                                                                > Watch More
                                                                                                    <i
                                                                                                            class="uil uil-video size-22 m-2 pr-1"
                                                                                                            title="watch video"></i>
                                                                                                </a>


                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>



                                                                        </div>

                                                                        <div class="swiper-pagination"></div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>

                                </div>





                                <!-- COLLAPSE - REGISTRATION FORM -->
                                <div id="collapseBizForm" class="collapse  p-0 " data-parent="#bizAccordion">
                                    <div class="card-body p-0">
                                        <div class="row">

                                            <div class="col-12">
                                                <h5 class="mb-3">Business Conference 2026 Registration </h5>
                                                <h5 class="mb-3"><span class="color-red">(Registration closed now)</span> </h5>

                                            </div>

                                            <div class="col-12 pb-3">
                                                <div class="section divider divider-gray"></div>
                                            </div>

                                            <div class="col-12 ">
                                                <form class="nfr-form-standard" [formGroup]="bizForm" (ngSubmit)="submitForm()">

                                                    <div class="row">
                                                        <div class="col-md-6 mb-3">
                                                            <label><small>*</small> First Name</label>
                                                            <input type="text" formControlName="firstName"
                                                                   class="form-style big with-border form-style-with-icon">
                                                        </div>

                                                        <div class="col-md-6 mb-3">
                                                            <label><small>*</small> Last Name</label>
                                                            <input type="text" formControlName="lastName"
                                                                   class="form-style big with-border form-style-with-icon">
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-md-6 mb-3">
                                                            <label><small>*</small> Email</label>
                                                            <input type="email" formControlName="email"
                                                                   class="form-style big with-border form-style-with-icon">
                                                        </div>

                                                        <div class="col-md-6 mb-3">
                                                            <label><small>*</small> Phone</label>
                                                            <input type="text" formControlName="phone"
                                                                   class="form-style big with-border form-style-with-icon">
                                                        </div>
                                                    </div>


                                                    <!-- Address Fields -->
                                                    <div class="row">
                                                        <div class="col-md-12 mb-3">
                                                            <label><small>*</small> Address Line 1</label>
                                                            <input type="text" formControlName="addressLine1"
                                                                   class="form-style big with-border form-style-with-icon">
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-md-12 mb-3">
                                                            <label>Address Line 2</label>
                                                            <input type="text" formControlName="addressLine2"
                                                                   class="form-style big with-border form-style-with-icon">
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-md-4 mb-3">
                                                            <label><small>*</small> City</label>
                                                            <input type="text" formControlName="city"
                                                                   class="form-style big with-border form-style-with-icon">
                                                        </div>

                                                        <div class="col-md-4 mb-3">
                                                            <label><small>*</small> State</label>
                                                            <select formControlName="state"
                                                                    class="form-style big with-border form-style-with-icon">
                                                                <option value="">Select State</option>
                                                                <option *ngFor="let s of states" [value]="s.code">{{
                                                                        s.name
                                                                    }}
                                                                </option>
                                                            </select>
                                                        </div>


                                                        <div class="col-md-4 mb-3">
                                                            <label><small>*</small> Zip Code</label>
                                                            <input type="text" formControlName="zipCode"
                                                                   class="form-style big with-border form-style-with-icon">
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-md-12 mb-3">
                                                            <label><small>*</small> Country</label>
                                                            <select formControlName="country"
                                                                    class="form-style big with-border form-style-with-icon">
                                                                <option value="">-- Select Country --</option>
                                                                <option value="USA">USA</option>
                                                                <option value="Canada">Canada</option>
                                                            </select>
                                                        </div>
                                                    </div>


                                                    <div class="form-group mb-3">
                                                        <input type="checkbox" formControlName="speaker"
                                                               class="form-check-input" id="speakerCheck">
                                                        <label class="checkbox mb-0 font-weight-500 size-15"
                                                               for="speakerCheck">
                                                            I am an invited speaker
                                                        </label>
                                                    </div>

                                                    <div class=" mb-3">
                                                        <label>Presentation Topic </label>
                                                        <input type="text" formControlName="topic"
                                                               class="form-style big with-border form-style-with-icon">
                                                    </div>


                                                    <div class="mb-3">
                                                        <label><small>*</small> Conference Package</label>
                                                        <select class="form-control"
                                                                class="form-style big with-border form-style-with-icon"
                                                                formControlName="packageType">
                                                            <option value="">-- Select Package --</option>
                                                            <option *ngFor="let p of packages" [value]="p.id">{{
                                                                    p.label
                                                                }}
                                                            </option>
                                                        </select>
                                                    </div>


                                                    <div class="form-group mb-3">
                                                        <input type="checkbox" formControlName="kidsOption"
                                                               class="form-check-input" id="kidsOptionCheck">
                                                        <label class="checkbox mb-0 font-weight-500 size-15"
                                                               for="kidsOptionCheck">
                                                            Kids Option (${{ kidsOptionUSD }} USD)
                                                        </label>
                                                    </div>


                                                    <div class="form-group mb-3">
                                                        <input type="checkbox" formControlName="additionalRoom"
                                                               class="form-check-input" id="additionalRoomCheck">
                                                        <label class="checkbox mb-0 font-weight-500 size-15"
                                                               for="additionalRoomCheck">
                                                            Additional Room ($295 USD)
                                                        </label>
                                                    </div>

                                                    <div class="mb-3">
                                                        <label>Donation Amount</label>
                                                        <select formControlName="donationAmount"
                                                                class="form-style big with-border form-style-with-icon">
                                                            <option value="">-- Select Donation --</option>
                                                            <option *ngFor="let d of donationOptions" [value]="d">{{
                                                                    d |
                                                                        currency:'USD':'symbol':'1.0-0'
                                                                }}
                                                            </option>
                                                        </select>
                                                    </div>


                                                    <div *ngIf="baseAmount > 0" class="alert alert-outline-warning m-3">
                                                        <p><strong>Base Amount:</strong> ${{ baseAmount }} USD</p>
                                                        <p *ngIf="roomAmount > 0"><strong>Room Option:</strong> ${{
                                                                roomAmount
                                                            }} USD</p>
                                                        <p *ngIf="kidsAmount > 0"><strong>Kids Option:</strong> ${{
                                                                kidsAmount
                                                            }} USD</p>
                                                        <!-- Donation Amount -->
                                                        <p *ngIf="bizForm.get('donationAmount')?.value > 0">
                                                            <strong>Donation:</strong> ${{
                                                                bizForm.get('donationAmount')?.value
                                                            }} USD
                                                        </p>
                                                        <p *ngIf="bizForm.get('paymentType')?.value === 'stripe'">
                                                            <strong>Stripe Surcharge (2.9% + $0.30):</strong> ${{
                                                                surcharge
                                                            }} USD
                                                        </p>
                                                        <p>
                                                            <strong>Total to Pay{{
                                                                    bizForm.get('paymentType')?.value ===
                                                                    'stripe' ? ' (Through Stripe)' : ''
                                                                }}:</strong>
                                                            ${{ totalWithSurcharge }} USD
                                                        </p>
                                                    </div>


                                                    <div class="form-group mb-3">
                                                        <label class="mb-2">Payment Method</label><br>

                                                        <!-- Stripe -->
                                                        <div class="form-check">
                                                            <input type="radio" id="payStripe" value="stripe"
                                                                   formControlName="paymentType"
                                                                   class="form-check-input">
                                                            <label class="radio mb-0 font-weight-500 size-15"
                                                                   for="payStripe">
                                                                Pay with Card (Stripe) <i
                                                                    class="uil uil-info-circle size-19 mr-2 pr-1"
                                                                    title="Online payments: 2.9% + 30¢ per transaction
International cards: Additional 1.5%
Currency conversion: Additional 1%"></i>
                                                            </label>
                                                        </div>

                                                        <!-- Zelle -->
                                                        <div class="form-check mt-1">
                                                            <input type="radio" id="payZelle" value="zelle"
                                                                   formControlName="paymentType"
                                                                   class="form-check-input">
                                                            <label class="radio mb-0 font-weight-500 size-15"
                                                                   for="payZelle">
                                                                Pay with Zelle
                                                            </label>
                                                        </div>

                                                        <!-- Check -->
                                                        <div class="form-check mt-1">
                                                            <input type="radio" id="payCheck" value="check"
                                                                   formControlName="paymentType"
                                                                   class="form-check-input">
                                                            <label class="radio mb-0 font-weight-500 size-15"
                                                                   for="payCheck">
                                                                Pay by Check
                                                            </label>
                                                        </div>
                                                    </div>


<!--                                                    <re-captcha  siteKey="6LdWYx0sAAAAAKWUO118-4JMP1w0CXQIBsqxYItw"-->
<!--                                                                (resolved)="onCaptchaResolved($event)" class="mb-3">-->
<!--                                                    </re-captcha>-->


                                                    <button class="btn btn-primary w-100" [disabled]="true">
                                                        Submit Registration
                                                    </button>

                                                </form>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <!-- COLLAPSE - CONFERENCE DETAILS -->
                                <div id="collapseBizDetails" class="collapse show p-0 " data-parent="#bizAccordion">
                                    <div class="card-body p-0 section-background-rana-biz-conf-full">
                                        <div class="row">

                                            <div class="col-12">
                                                <h5 class="mb-3 text-detail">Business Conference 2026 – Details &
                                                    Pricing</h5>
                                            </div>

                                            <div class="col-12 pb-3">
                                                <div class="section divider divider-gray"></div>
                                            </div>

                                            <div class="col-12 ">

                                                <h6 class="mb-2 text-detail  p-0">📅 Event Dates</h6>
                                                <p class="text-detail">Friday, Jan 30th – Sunday, February 1st, 2026</p>

                                                <h6 class="mt-4 mb-2 text-detail">📍 Venue</h6>
                                                <p class="text-detail">
                                                    Magnoliya Grand Conference & Event Center<br>
                                                    6991 Infantry Ridge Rd, <br>
                                                    Manassas, VA 20109
                                                </p>

                                                <h6 class="mt-4 mb-2 text-detail">💳 Payment Details</h6>
                                                <p class="text-detail">
                                                    <b>Payment Mode:</b> Zelle or PayPal<br>
                                                    <b>Email:</b> account&#64;rajputra.org
                                                </p>

                                                <h6 class="mt-4 mb-2 text-detail">🧾 Registration Fees</h6>
                                                <ul>
                                                    <li><b>Adult Single Room:</b> $450 USD</li>
                                                    <li><b>Adult Shared Room:</b> $325 USD</li>
                                                    <li><b>Couple:</b> $650 USD</li>
                                                    <li><b>Kids (covering food):</b> $185 USD</li>
                                                </ul>

                                                <h6 class="mt-4 mb-2 text-detail">🏨 Additional Options</h6>
                                                <ul>
                                                    <li><b>Additional Room:</b> $295 USD</li>

                                                </ul>

                                                <h6 class="mt-4 mb-2 text-detail">🍽 For Local Attendees</h6>
                                                <ul>
                                                    <li><b>Full Event Food Only:</b> $300 USD</li>

                                                </ul>

                                                <h6 class="mt-4 mb-2 text-detail">📬 Mailing Address for Checks</h6>
                                                <p class="text-detail">
                                                    6611 Chesterfield Ave<br>
                                                    Mclean, VA. 22101, USA
                                                </p>

                                            </div>

                                        </div>
                                    </div>
                                </div>


                            </div><!-- accordion wrapper -->
                        </div>

                    </div>
                </div>
            </div>
        </div>











    </div>
</div>
